cv.generateWarningLabels = function(view, model){
  console.log('Checking warning labels... ');

  var status = cv.getStatus(model);
  var fields = status.fields;
  var has_incomplete_form = false;

  _.each(fields, function(value, key, list){
    if(value == true){
      has_incomplete_form = true;
      view.$('#' + key).parents('.form-group').addClass('has-warning');
    }else{
      view.$('#' + key).parents('.form-group').removeClass('has-warning');
    }
  }, this);

  // Generate the warning label for top

  // Generate warning label for the sidebar
};
